;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export const ORGANISATION_SWITCH_COOKIE_KEY = 'organisation_switch_event';

const ORGANISATION_SWITCH_LAST_SEEN_KEY = 'organisation_switch_event_last_seen';

export function createOrganisationSwitchMarkerValue(organisationId: number): string {
  return `${organisationId}:${Date.now()}`;
}

function readCookieValue(name: string): string | null {
  if (typeof document === 'undefined') return null;

  const cookie = document.cookie
    .split('; ')
    .find((cookiePart) => cookiePart.startsWith(`${name}=`));

  if (!cookie) return null;

  return decodeURIComponent(cookie.slice(name.length + 1));
}

function getLastSeenMarker(): string | null {
  return window.sessionStorage.getItem(ORGANISATION_SWITCH_LAST_SEEN_KEY);
}

function setLastSeenMarker(value: string): void {
  window.sessionStorage.setItem(ORGANISATION_SWITCH_LAST_SEEN_KEY, value);
}

export function markCurrentOrganisationSwitchSeen(): void {
  if (typeof window === 'undefined') return;

  const marker = readCookieValue(ORGANISATION_SWITCH_COOKIE_KEY);
  if (marker) setLastSeenMarker(marker);
}

export function subscribeToCrossAppOrganisationSwitch(callback: () => void): () => void {
  if (typeof window === 'undefined') return () => {};

  markCurrentOrganisationSwitchSeen();

  const checkMarker = () => {
    const marker = readCookieValue(ORGANISATION_SWITCH_COOKIE_KEY);
    if (!marker) return;
    if (marker === getLastSeenMarker()) return;

    setLastSeenMarker(marker);
    callback();
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState !== 'visible') return;
    checkMarker();
  };

  window.addEventListener('focus', checkMarker);
  document.addEventListener('visibilitychange', handleVisibilityChange);

  const intervalId = window.setInterval(checkMarker, 30_000);

  return () => {
    window.removeEventListener('focus', checkMarker);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    window.clearInterval(intervalId);
  };
}
